/**
 * Autorité textuelle versionnée des actifs financiers du checkpoint 5.4.1.
 * Ces transformations doivent rester identiques entre migration, écriture et recherche.
 */
export function canonicalizeFinancialCodeV1(value: string): string {
  return value.normalize('NFKC').trim().toUpperCase();
}

export function canonicalizeFinancialSearchTextV1(value: string): string {
  return value.normalize('NFKC').trim().replace(/\s+/gu, ' ').toLowerCase();
}

/**
 * Recherche à la fois le texte tel qu'il a été saisi et sa forme de code.
 * Cette seconde forme couvre notamment le pli Unicode `straße` -> `STRASSE`.
 */
export function financialSearchVariantsV1(value: string): readonly string[] {
  const text = canonicalizeFinancialSearchTextV1(value);
  const code = canonicalizeFinancialSearchTextV1(canonicalizeFinancialCodeV1(value));
  return text === code ? [text] : [text, code];
}
